import { createContext, type ReactNode, useEffect, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import { themes } from '../assets/styles/themes';
import { storageKeys } from '../config/storageKeys';

interface IThemeContextValue {
	theme: string;
	handleToggleTheme(): void;
}

export const ThemeContext = createContext({} as IThemeContextValue);

export function CustomThemeProvider({ children }: { children: ReactNode }) {
	const [theme, setTheme] = useState(() => {
		return localStorage.getItem(storageKeys.theme) || 'light';
	});

	function handleToggleTheme() {
		setTheme((prevState) => (prevState === 'light' ? 'dark' : 'light'));
	}

	const value: IThemeContextValue = {
		theme,
		handleToggleTheme
	};

	useEffect(() => {
		localStorage.setItem(storageKeys.theme, theme);
	}, [theme]);

	return (
		<ThemeContext.Provider value={value}>
			<ThemeProvider theme={theme === 'light' ? themes.light : themes.dark}>
				{children}
			</ThemeProvider>
		</ThemeContext.Provider>
	);
}
